/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import type { LoginCredentials, RootState, Dispatch } from '../types'

import type { Props } from './LoginForm/'
import LoginForm from './LoginForm/'
import { loginButtonClick } from '../sagas/login'
import { setLoginForm, selectLoginForm } from '../stores/loginForm'
import { selectIsLoggingIn } from '../stores/pending'
import { selectCurrentUser } from '../stores/currentUser'
import { goToOldLibrary } from '../stores/routing'

type State = {
  credentials: LoginCredentials,
  isLoggingIn: boolean,
}

class LoginPage extends React.Component<Props, State> {
  componentDidMount() {
    const { currentUser, goToOldLibrary } = this.props
    if (!currentUser) return
    goToOldLibrary()
  }

  render() {
    return (
      <div className="bg-white pa4 flex justify-center">
        <LoginForm {...this.props} />
      </div>
    )
  }
}

function mapStateToProps(state: RootState): State {
  return {
    credentials: selectLoginForm(state),
    isLoggingIn: selectIsLoggingIn(state),
    currentUser: selectCurrentUser(state),
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loginButtonClick(credentials) {
      return dispatch(loginButtonClick(credentials))
    },
    setCredentials(credentials) {
      return dispatch(setLoginForm(credentials))
    },
    goToOldLibrary() {
      return dispatch(goToOldLibrary())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage)



// WEBPACK FOOTER //
// ./src/components/LoginPage.js